/* ══════════════════════════════════════════════════════════════════════
   RENDERFLOW — comportements

   Un seul fichier, six services : la galerie, les cases dépliantes, les
   apparitions au défilement, le menu rideau, le sigle qui suit le
   curseur, et deux commodités pour les pages de compte.

   ── Pourquoi tout est écrit en fonctions rappelables ──
   Dans l'éditeur de thème, Shopify ne recharge pas la page quand le
   marchand modifie une section : il remplace le morceau de HTML et émet
   shopify:section:load. Un script qui ne s'exécute qu'au chargement
   laisse alors une section morte — le marchand change son menu, et le
   menu ne s'ouvre plus. Chaque initialisation est donc rejouable, et
   marque ce qu'elle a déjà câblé pour ne pas le faire deux fois.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var EDITEUR = window.Shopify && window.Shopify.designMode;

  /* Une adresse comparable : sans ancre, sans requête, sans barre finale.
     « /collections/all » et « /collections/all/ » sont la même page mais
     ne se comparent pas comme telles. */
  function propre(u) {
    if (!u) return '/';
    u = String(u).split('#')[0].split('?')[0];
    if (u.length > 1 && u.charAt(u.length - 1) === '/') u = u.slice(0, -1);
    return u || '/';
  }

  function neuf(el, cle) {
    if (el.dataset[cle]) return false;
    el.dataset[cle] = '1';
    return true;
  }

  /* ── La galerie ────────────────────────────────────────────────────
     La vignette cliquée devient la grande vue. aria-current porte
     l'état : un cadre plus clair ne dit rien à qui n'y voit pas.

     Trois cadres possibles, choisis par la vignette :
       — data-tel   : un téléphone, pour un enregistrement d'écran mobile
       — data-boite : un carré, pour un visuel de coffret
       — sinon      : le format large d'une capture d'écran

     Les vidéos ne sont posées qu'AU CLIC. Écrites d'emblée dans la page,
     leurs mégaoctets partiraient au chargement, avant qu'on sache si le
     visiteur les regardera. */
  function galerie(racine) {
    var vue = racine.querySelector('[data-gal-vue]');
    if (!vue) return;
    var minis = racine.querySelectorAll('[data-gal-mini]');

    minis.forEach(function (m) {
      if (!neuf(m, 'galCable')) return;
      m.addEventListener('click', function () {
        minis.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        m.setAttribute('aria-current', 'true');

        var leg  = m.querySelector('span');
        var nom  = leg ? leg.textContent : '';
        var img  = m.querySelector('img');
        var film = m.getAttribute('data-video');

        vue.classList.remove('gal-vue--tel', 'gal-vue--boite');

        if (film) {
          var tel = m.hasAttribute('data-tel');
          if (tel) vue.classList.add('gal-vue--tel');
          var affiche = img ? ' poster="' + img.getAttribute('src') + '"' : '';
          var lecteur = '<video src="' + film + '"' + affiche +
                        ' autoplay muted loop playsinline' +
                        (tel ? '' : ' controls') + '></video>';
          /* Pas de contrôles natifs dans le téléphone : la barre de
             lecture s'afficherait À L'INTÉRIEUR de l'écran, comme si elle
             faisait partie de la boutique montrée. */
          vue.innerHTML = tel
            ? '<div class="tel"><div class="tel-ecran">' + lecteur + '</div></div>'
            : lecteur;
        } else if (img) {
          if (m.hasAttribute('data-boite')) vue.classList.add('gal-vue--boite');
          vue.innerHTML = '<img src="' + img.getAttribute('src') + '" alt="' + nom + '">';
        } else {
          vue.innerHTML = '<em>' + nom + '</em>';
        }
      });
    });
  }

  /* ── Cases dépliantes ──────────────────────────────────────────────
     Indépendantes : ouvrir la description ne referme pas la licence. On
     compare souvent deux réponses côte à côte. */
  function deplier(racine) {
    racine.querySelectorAll('.acc-b').forEach(function (b) {
      if (!neuf(b, 'accCable')) return;
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        /* closest et non parentElement : les questions enveloppent leur
           bouton dans un <h3> — le motif ARIA recommandé pour un
           accordéon, où le titre porte le niveau et le bouton
           l'interaction. Avec parentElement la classe atterrissait sur
           le h3 et le CSS ne la voyait jamais, donc plus rien ne
           s'ouvrait. closest remonte jusqu'au vrai conteneur, quel que
           soit ce qu'on interpose entre les deux. */
        var item = b.closest('.acc-i') || b.parentElement;
        var ouvert = item.classList.toggle('on');
        b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    });
  }

  /* ── Le sigle du pied qui ramène en haut ──────────────────────────
     Sur une AUTRE page, on laisse le lien faire son travail : la
     navigation normale, avec le fondu de page déjà en place.

     Sur l'accueil, recharger la même page pour remonter serait absurde
     et coûterait un aller-retour réseau. On intercepte donc, et on
     remonte en douceur — sans toucher à l'adresse, pour ne pas ajouter
     une entrée d'historique à chaque clic.

     prefers-reduced-motion est respecté : un défilement animé de toute
     la hauteur d'une page est exactement ce que ce réglage existe pour
     supprimer. */
  function retourHaut(racine) {
    racine.querySelectorAll('[data-haut]').forEach(function (a) {
      if (!neuf(a, 'hautCable')) return;
      a.addEventListener('click', function (e) {
        var ici = location.pathname.replace(/\/+$/, '');
        var cible = (a.getAttribute('href') || '').replace(/\/+$/, '');
        if (ici !== cible) return;
        e.preventDefault();
        var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: doux ? 'smooth' : 'auto' });
      });
    });
  }

  /* ── Apparitions au défilement ─────────────────────────────────── */
  var io = null;
  function reveler(racine) {
    if (document.documentElement.hasAttribute('data-sans-reveal')) return;
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    racine.querySelectorAll('.rv').forEach(function (el) {
      if (neuf(el, 'rvCable')) io.observe(el);
    });
  }

  /* ── Le menu rideau ────────────────────────────────────────────────
     Une seule timeline GSAP, jouée en avant pour ouvrir et rembobinée
     pour fermer. C'est le point qui règle les saccades : deux animations
     séparées, chacune avec ses délais, ne repartent jamais exactement en
     sens inverse. Un ruban rembobiné, si.

     ⚠️ Aucun preventDefault sur les liens : c'est px.js qui intercepte
        les clics et pose le voile. Reprendre la navigation ici couperait
        la transition de page. */
  var COURBE = 'M100 0 L200 0 L200 1000 L100 1000 Q-100 500 100 0';
  var DROIT  = 'M100 0 L200 0 L200 1000 L100 1000 Q100 500 100 0';

  function menu(racine) {
    if (typeof gsap === 'undefined') return;

    var bouton = racine.querySelector('#mbtn');
    var panneau = racine.querySelector('#menu');
    if (!bouton || !panneau) return;
    if (!neuf(panneau, 'menuCable')) return;

    var trace = panneau.querySelector('#menu-trace');
    var liens = Array.prototype.slice.call(panneau.querySelectorAll('.menu-l'));
    var puces = panneau.querySelectorAll('.menu-dot');
    if (!trace) return;

    trace.setAttribute('d', COURBE);

    /* La largeur du panneau plus les 100 px du bord courbe : sans eux, la
       courbe resterait visible au bord de l'écran, menu fermé. Passée en
       fonction et non en nombre — GSAP la relit à chaque invalidate(),
       donc au redimensionnement. */
    function dehors() { return panneau.offsetWidth + 100; }

    var tl = gsap.timeline({
      paused: true,
      defaults: { duration: 0.8, ease: 'power3.inOut' },
      onReverseComplete: function () {
        panneau.classList.remove('on');
        panneau.setAttribute('aria-hidden', 'true');
      }
    });

    tl.fromTo(panneau, { x: dehors }, { x: 0 }, 0)
      .fromTo(trace, { attr: { d: COURBE } }, { attr: { d: DROIT }, duration: 1 }, 0)
      .fromTo(liens, { x: 80 }, { x: 0, stagger: 0.05 }, 0);

    function ouvert() { return !tl.reversed() && tl.progress() > 0; }

    /* La pastille marque la page où l'on se trouve, et rien d'autre. Elle
       ne suit PAS le curseur : un repère qui bouge dès qu'on regarde
       ailleurs n'est plus un repère. Le survol se dit autrement — le lien
       pâlit, c'est du CSS, et ça n'efface pas la position courante. */
    var ici = propre(location.pathname);
    function pastille(cible) {
      liens.forEach(function (l) {
        gsap.to(l.querySelector('.menu-dot'), {
          scale: propre(l.getAttribute('data-href')) === cible ? 1 : 0,
          duration: 0.3, ease: 'power2.out'
        });
      });
    }

    /* Un lien vers une ancre d'une AUTRE page reste une traversée ; sur la
       page elle-même, il redevient une simple ancre. Sans ça, px.js
       rechargerait la page entière pour descendre de deux écrans. */
    liens.forEach(function (l) {
      var a = l.querySelector('a');
      if (!a) return;
      var h = a.getAttribute('href') || '';
      var d = h.indexOf('#');
      if (d > 0 && propre(h.slice(0, d)) === ici) a.setAttribute('href', h.slice(d));
    });

    function ouvrir() {
      /* Un drapeau sur <body> : le panneau et le sac du panier ne sont
         pas dans le même parent, aucun sélecteur de frère ne peut les
         relier. La classe sur la racine, elle, est lisible de partout. */
      document.body.classList.add('menu-on');
      panneau.classList.add('on');
      panneau.setAttribute('aria-hidden', 'false');
      bouton.classList.add('on');
      bouton.setAttribute('aria-expanded', 'true');
      tl.play();
      pastille(ici);
    }

    function fermer() {
      document.body.classList.remove('menu-on');
      bouton.classList.remove('on');
      bouton.setAttribute('aria-expanded', 'false');
      gsap.to(puces, { scale: 0, duration: 0.3 });
      tl.reverse();
    }

    bouton.addEventListener('click', function () { ouvert() ? fermer() : ouvrir(); });

    /* Un clic sur un lien : deux cas.
       — Une ancre, un courriel, un onglet neuf : rien ne change de page,
         il faut donc refermer le panneau pour de bon.
       — Une vraie traversée : px.js pose le voile et la page suivante
         arrive avec son propre panneau fermé. On éteint seulement le
         bouton — l'animation de fermeture se jouerait derrière le voile,
         pour personne. */
    panneau.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || a.target === '_blank' ||
          /^(mailto|tel):/.test(href)) { fermer(); return; }
      document.body.classList.remove('menu-on');
      bouton.classList.remove('on');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ouvert()) fermer();
    });

    window.addEventListener('resize', function () {
      if (ouvert()) return;
      tl.invalidate();
      gsap.set(panneau, { x: dehors() });
    });
  }

  /* ── Le sigle qui suit le curseur ──────────────────────────────────
     Deux mouvements sur la même source : un déplacement, et une bascule
     en trois dimensions. Le déplacement seul donnerait un autocollant qui
     glisse ; c'est l'inclinaison qui fait croire à un objet posé devant
     la page.

     quickTo plutôt qu'un tween par événement : la souris envoie des
     dizaines de messages par seconde, et créer autant de tweens les
     empilerait. quickTo réutilise le même et se contente de changer sa
     destination — le sigle rattrape le curseur avec du retard, et c'est
     ce retard qui donne le poids. */
  function parallaxe(racine) {
    if (typeof gsap === 'undefined') return;
    var sigle = racine.querySelector('[data-parallaxe]');
    if (!sigle || !neuf(sigle, 'paraCable')) return;
    if (!window.matchMedia) return;
    /* Sans curseur, il n'y a rien à suivre. Et un visiteur qui a demandé
       moins d'animations ne veut pas d'un logo qui bouge. */
    if (matchMedia('(hover: none)').matches) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var COURSE = 26, BASCULE = 7;
    var vers = { duration: 0.9, ease: 'power3' };
    var x  = gsap.quickTo(sigle, 'x',         vers);
    var y  = gsap.quickTo(sigle, 'y',         vers);
    var rx = gsap.quickTo(sigle, 'rotationX', vers);
    var ry = gsap.quickTo(sigle, 'rotationY', vers);

    window.addEventListener('mousemove', function (e) {
      /* Rapporter la position à la FENÊTRE et non au sigle : sinon le
         mouvement s'inverserait dès que le curseur passe de l'autre côté
         de lui. */
      var dx = (e.clientX / innerWidth  - 0.5) * 2;
      var dy = (e.clientY / innerHeight - 0.5) * 2;
      x(dx * COURSE); y(dy * COURSE);
      /* rotationX inversé : pousser le curseur vers le bas doit coucher
         le haut du sigle vers l'arrière, pas vers l'avant. */
      ry(dx * BASCULE); rx(-dy * BASCULE);
    });

    gsap.from(sigle, { opacity: 0, scale: 0.94, duration: 1.1,
                       ease: 'power3.out', delay: 0.15 });
  }

  /* ── Les écrans de compte ──────────────────────────────────────────
     Deux services que Shopify ne rend pas : déplier un formulaire de
     modification d'adresse, et présélectionner le pays d'une adresse
     existante. all_country_option_tags rend la liste complète des pays
     mais ne sait pas cocher celui qui est enregistré — sans ces lignes,
     modifier son adresse la remettrait sur le premier pays de la liste. */
  function compte(racine) {
    racine.querySelectorAll('[data-deplier]').forEach(function (b) {
      if (!neuf(b, 'depCable')) return;
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var cible = document.getElementById(b.getAttribute('data-deplier'));
        if (!cible) return;
        cible.hidden = !cible.hidden;
        b.setAttribute('aria-expanded', cible.hidden ? 'false' : 'true');
      });
    });

    racine.querySelectorAll('select[data-country]').forEach(function (s) {
      if (!neuf(s, 'paysCable')) return;
      var pays = s.getAttribute('data-country');
      if (pays) s.value = pays;
    });
  }

  /* ── Le panier ─────────────────────────────────────────────────────
     Trois services : ouvrir et fermer le tiroir, ajouter sans quitter la
     page, et changer une quantité sans recharger.

     ── Le point qui fait tout tenir ──
     Après chaque écriture (/cart/add.js, /cart/change.js), on redemande
     au serveur la SECTION du tiroir, déjà calculée par Shopify, et on
     remplace le morceau de page. Prix, remises, devise, seuils de
     livraison : tout vient de Shopify. Reconstruire le panier en
     JavaScript, c'est se condamner à afficher un total qui finira par ne
     plus correspondre à celui de la caisse.

     ⚠️ Le tiroir est REMPLACÉ à chaque mise à jour : aucun gestionnaire
        ne peut être attaché à ses éléments. Tout passe par des écouteurs
        posés sur document, qui survivent au remplacement. */
  var TIROIR = 'tiroir-panier';

  /* Une boutique peut vivre sous un sous-dossier (/fr/, /en/…). Shopify
     l'expose ; sans lui, /cart/change.js taperait à côté sur ces
     boutiques-là. */
  function racineShopify() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function tiroirEl()  { return document.getElementById('tiroir'); }
  function voileEl()   { return document.getElementById('tiroir-voile'); }

  function ouvrirPanier() {
    var t = tiroirEl(), v = voileEl();
    if (!t || !v) return;
    v.hidden = false;
    /* Une image d'attente : un élément qui passe de hidden à visible ET
       change de transform dans la même image n'anime pas, il apparaît. */
    requestAnimationFrame(function () { v.classList.add('on'); t.classList.add('on'); });
    t.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function fermerPanier() {
    var t = tiroirEl(), v = voileEl();
    if (!t || !v) return;
    v.classList.remove('on');
    t.classList.remove('on');
    t.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { if (!t.classList.contains('on')) v.hidden = true; }, 500);
  }

  /* ── Le rafraîchissement ────────────────────────────────────────────
     UNE seule requête, la même depuis n'importe quelle page : on
     télécharge /cart en HTML et on y prend ce dont on a besoin.

     Pourquoi pas l'API de rendu de section (?sections=) : parce qu'elle
     ne se comporte pas pareil selon la page d'où on l'appelle. Depuis
     l'accueil elle répondait, depuis la fiche produit elle traînait ou
     renvoyait un état périmé, et depuis /cart elle ne rendait pas la
     section de la page. Trois pages, trois comportements — on répare un
     écran et on en casse un autre.

     /cart est la page idéale pour cette requête : elle est légère, et
     elle contient LES DEUX morceaux qui nous intéressent — le tiroir,
     qui vient de la mise en page et se trouve donc partout, et la liste
     du panier, qui n'existe que là. Une requête, deux morceaux, le même
     code sur toutes les pages.

     On ne recalcule jamais un total en JavaScript : les montants qu'on
     affiche sont ceux que Shopify vient de rendre. */
  /* Un morceau fraîchement inséré remplace du contenu DÉJÀ visible. Or
     les éléments .rv partent à opacity:0 et n'attendent que l'observateur
     de défilement — qui ne les a jamais vus, puisqu'ils viennent de
     naître. Résultat : la page se vide.

     On ne les fait pas apparaître en fondu : ce n'est pas une entrée,
     c'est une mise à jour. Un total qui se rallume en fondu à chaque
     clic sur « + » donnerait le tournis. On les marque donc comme déjà
     révélés, et déjà câblés pour que reveler() ne les reprenne pas. */
  function montrer(noeud) {
    if (!noeud) return;
    if (noeud.classList && noeud.classList.contains('rv')) {
      noeud.classList.add('in');
      noeud.dataset.rvCable = '1';
    }
    if (!noeud.querySelectorAll) return;
    noeud.querySelectorAll('.rv').forEach(function (el) {
      el.classList.add('in');
      el.dataset.rvCable = '1';
    });
  }

  function rafraichir(ouvre) {
    return fetch(racineShopify() + 'cart?_=' + Date.now(), {
      headers: { Accept: 'text/html' }, cache: 'no-store', credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var frais = new DOMParser().parseFromString(html, 'text/html');

        /* ── Le tiroir ── */
        var ancien = tiroirEl();
        var neufTiroir = frais.querySelector('#tiroir');
        if (ancien && neufTiroir) {
          /* Le tiroir remplacé pendant qu'il est ouvert ne doit pas se
             refermer sous les doigts. */
          var etaitOuvert = ancien.classList.contains('on');
          if (etaitOuvert) neufTiroir.classList.add('on');

          var v = voileEl();
          var neufVoile = frais.querySelector('#tiroir-voile');
          if (v && neufVoile) {
            neufVoile.hidden = v.hidden;
            if (etaitOuvert) neufVoile.classList.add('on');
            v.replaceWith(document.importNode(neufVoile, true));
          }
          var poseT = document.importNode(neufTiroir, true);
          montrer(poseT);
          ancien.replaceWith(poseT);
        } else {
          console.warn('[panier] tiroir introuvable',
                       { surLaPage: !!ancien, dansLaReponse: !!neufTiroir });
        }

        /* ── La page panier, si c'est elle qu'on regarde ── */
        var vieuxP = document.querySelector('[data-panier-page]');
        var neufP  = frais.querySelector('[data-panier-page]');
        if (vieuxP && neufP) {
          var poseP = document.importNode(neufP, true);
          montrer(poseP);
          vieuxP.replaceWith(poseP);
        }

        /* ── Le compteur de la barre ──
           Il vit hors du tiroir : il se met à jour depuis le nombre que
           Shopify vient de rendre, pas depuis un calcul local. */
        var tete = document.querySelector('.tiroir-tete .mono');
        var m = tete && tete.textContent.match(/\((\d+)\)/);
        if (m) {
          var n = parseInt(m[1], 10);
          document.querySelectorAll('[data-panier-compteur]').forEach(function (el) {
            el.classList.toggle('on', n > 0);
            var b = el.querySelector('b');
            if (b) b.textContent = n;
          });
        }

        if (ouvre) ouvrirPanier();
      })
      .catch(function (e) {
        console.warn('[panier] rafraîchissement impossible', e);
      });
  }

  function panier() {
    if (document.body.dataset.panierCable) return;
    document.body.dataset.panierCable = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-panier-fermer]')) { e.preventDefault(); fermerPanier(); return; }
      if (e.target.closest('#tiroir-voile'))        { fermerPanier(); return; }

      var ouvrir = e.target.closest('[data-panier-ouvrir]');
      if (ouvrir && tiroirEl()) { e.preventDefault(); ouvrirPanier(); return; }

      /* Une quantité. Le lien reste un vrai lien — il faut que ça marche
         sans script — mais on ne le SUIT pas : /cart/change répond par
         une redirection vers /cart, que fetch suit en silence, et on se
         retrouve à lire une page entière pour rien. On lit ses deux
         paramètres et on parle à l'API du panier, qui répond par l'état
         du panier et rien d'autre. */
      var q = e.target.closest('[data-qte]');
      var href = q && q.getAttribute('href');
      if (href) {
        e.preventDefault();
        var ligne = (href.match(/[?&]line=(\d+)/)  || [])[1];
        var combien = (href.match(/[?&]quantity=(\d+)/) || [])[1];
        if (ligne === undefined || combien === undefined) { location.href = href; return; }

        /* ── La réponse immédiate ──────────────────────────────────
           Le chiffre change AVANT que le serveur ait répondu. Ce n'est
           pas un calcul : la nouvelle quantité est déjà dans l'adresse
           du lien, écrite par Liquid — on ne fait que l'afficher plus
           tôt. Les montants, eux, attendent Shopify : un sous-total
           deviné en JavaScript finit toujours par mentir.

           Sans ça, deux allers-retours passent sans que rien ne bouge à
           l'écran, et le clic paraît perdu. C'est cette attente muette
           qui donne l'impression de lourdeur, pas sa durée. */
        var bloc = q.closest('.qte');
        var chiffre = bloc && bloc.querySelector('span');
        if (chiffre) chiffre.textContent = combien;

        var ligneEl = q.closest('.tl');
        if (ligneEl) ligneEl.classList.add('tl--attente');

        fetch(racineShopify() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store', credentials: 'same-origin',
          body: JSON.stringify({ line: Number(ligne), quantity: Number(combien) })
        })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function () { return rafraichir(false); })
        .catch(function () { location.href = href; });
      }
    });

    document.addEventListener('keydown', function (e) {
      var t = tiroirEl();
      if (e.key === 'Escape' && t && t.classList.contains('on')) fermerPanier();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-achat]');
      if (!form) return;
      e.preventDefault();
      var bouton = form.querySelector('button[type="submit"]');
      if (bouton) bouton.setAttribute('aria-busy', 'true');

      fetch(racineShopify() + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' },
        cache: 'no-store', credentials: 'same-origin',
        body: new FormData(form)
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        /* On ouvre TOUT DE SUITE, avec le tiroir déjà présent dans la
           page, puis on va chercher son contenu à jour. L'ordre inverse
           faisait dépendre l'ouverture de la réussite du rafraîchissement :
           un aléa réseau, et l'article était bien ajouté sans que rien
           ne bouge à l'écran — le client cliquait trois fois. */
        ouvrirPanier();
        return rafraichir(false);
      })
      .catch(function () { form.submit(); })
      .then(function () { if (bouton) bouton.removeAttribute('aria-busy'); });
    });
  }

  /* ── Le consentement ───────────────────────────────────────────────
     Le vrai verrou est le `required` de la case : le navigateur refuse
     d'envoyer le formulaire, script ou pas. Ce qui suit n'est que de la
     politesse — un bouton visiblement inactif vaut mieux qu'un bouton
     cliquable qui ne fait rien.

     Écouteur délégué sur le document : le tiroir réécrit son contenu à
     chaque ajout au panier, et une case fraîchement rendue doit rester
     câblée sans qu'on y repense. */
  function consentement(racine) {
    racine.querySelectorAll('.consent-case').forEach(function (c) {
      var form = c.closest('form');
      if (!form) return;
      var bouton = form.querySelector('button[name="checkout"]');
      if (bouton) bouton.disabled = !c.checked;
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('consent-case')) return;
    var form = e.target.closest('form');
    var bouton = form && form.querySelector('button[name="checkout"]');
    if (bouton) bouton.disabled = !e.target.checked;
  });

  /* ── Le nom, ajusté à la largeur ───────────────────────────────────
     RENDERFLOW doit toucher les deux bords de son panneau : dans le
     menu, du I d'Instagram au m de l'adresse mail ; dans le tiroir, du
     C de Cart au e de Close.

     Pourquoi pas une taille en CSS ? La police d'affichage est
     « Helvetica Neue, Helvetica, Arial » — trois métriques pour trois
     machines. Un font-size en dur cadre juste là où on l'a réglé, et
     laisse un trou ou déborde ailleurs. On mesure le mot une fois et on
     en déduit la taille : la relation est linéaire, un calcul suffit.

     Rejouable comme le reste : dans l'éditeur, le marchand change le mot
     et Shopify remplace la section — il faut le remesurer. */
  var regleNom = document.createRange();

  function ajusterNom(mot) {
    var st = getComputedStyle(mot);
    var dispo = mot.clientWidth
              - parseFloat(st.paddingLeft) - parseFloat(st.paddingRight);
    if (!(dispo > 0)) return;

    /* Mesure à 100 px : assez grand pour que l'arrondi au pixel ne pèse
       plus rien une fois ramené à l'échelle. */
    var pose = mot.style.fontSize;
    mot.style.fontSize = '100px';
    regleNom.selectNodeContents(mot);
    var avance = regleNom.getBoundingClientRect().width / 100;
    /* letter-spacing s'applique AUSSI après la dernière lettre. En
       tracking négatif — .logo-mot est à -.05em — la boîte d'avance se
       referme donc en deçà de l'encre. Sans lui rendre ce retrait, le
       mot s'arrêterait avant le bord droit. */
    var traine = (parseFloat(getComputedStyle(mot).letterSpacing) || 0) / 100;
    mot.style.fontSize = pose;

    if (!(avance > 0)) return;
    mot.style.fontSize = (dispo / (avance - traine)) + 'px';
  }

  function nom(racine) {
    racine.querySelectorAll('[data-ajuster]').forEach(ajusterNom);
  }

  function tout(racine) {
    racine = racine || document;
    galerie(racine);
    deplier(racine);
    retourHaut(racine);
    reveler(racine);
    menu(racine);
    parallaxe(racine);
    compte(racine);
    nom(racine);
    consentement(racine);
    panier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tout(document); });
  } else {
    tout(document);
  }

  /* Le mot se remesure quand la fenêtre change de largeur, et quand une
     police de repli cède la place à la vraie sous un mot déjà posé.
     Posés ici et non dans tout(), qui est rejoué à chaque section. */
  window.addEventListener('resize', function () { nom(document); });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { nom(document); });
  }

  /* L'éditeur remplace un morceau de HTML sans recharger la page : on
     recâble ce morceau, et lui seul. */
  if (EDITEUR) {
    document.addEventListener('shopify:section:load', function (e) { tout(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var acc = e.target.querySelector ? e.target.querySelector('.acc-i') : null;
      if (acc) acc.classList.add('on');
    });
  }
})();
